import React from "react";
import { Link } from "react-router-dom";
import { FaUserAlt, FaUserGraduate } from "react-icons/fa";

const uniformData = [
  {
    title: "Boys - Weekdays (Summer)",
    image: "/assets/uniform/boys-weekday-summer.jpg",
    items: [
      "Pink shirt and Black Trouser",
      "Black tie and belt",
      "Black shoes with white socks",
    ],
    color: "#3b82f6",
    border: "rgba(59,130,246,0.2)",
  },
  {
    title: "Boys - Wed/Sat (Summer)",
    image: "/assets/uniform/boys-sat-summer.jpg",
    items: [
      "House polo T-shirt and sweatpants (color-coded)",
      "Black shoes and woolen socks",
    ],
    color: "#22c55e",
    border: "rgba(34,197,94,0.2)",
  },
  {
    title: "Boys - Weekdays (Winter)",
    image: "/assets/uniform/boys-weekday-winter.jpg",
    items: [
      "Full-sleeve pink shirt and black trousers",
      "Black tie and belt",
      "Grey sweater and black blazer",
      "Woolen socks and black shoes",
    ],
    color: "#06b6d4",
    border: "rgba(6,182,212,0.2)",
  },
  {
    title: "Boys - Wed/Sat (Winter)",
    image: "/assets/uniform/boys-sat-winter.jpg",
    items: [
      "House jacket and sweatpants (color-coded)",
      "Black shoes and woolen socks",
    ],
    color: "#6366f1",
    border: "rgba(99,102,241,0.2)",
  },
  {
    title: "Girls - Weekdays (Summer)",
    image: "/assets/uniform/girls-weekday-summer.jpg",
    items: [
      "Pink shirt and Black Tunic/trouser",
      "Black tie and belt",
      "Black shoes with white socks",
    ],
    color: "#ec4899",
    border: "rgba(236,72,153,0.2)",
  },
  {
    title: "Girls - Wed/Sat (Summer)",
    image: "/assets/uniform/girls-sat-summer.jpg",
    items: [
      "House polo T-shirt and sweatpants (color-coded)",
      "Black shoes and woolen socks",
    ],
    color: "#f97316",
    border: "rgba(249,115,22,0.2)",
  },
  {
    title: "Girls - Weekdays (Winter)",
    image: "/assets/uniform/girls-weekday-winter.jpg",
    items: [
      "Full-sleeve pink shirt and black trousers",
      "Black tie and belt",
      "Grey sweater and black blazer",
      "Woolen socks and black shoes",
    ],
    color: "#c084fc",
    border: "rgba(192,132,252,0.2)",
  },
  {
    title: "Girls - Wed/Sat (Winter)",
    image: "/assets/uniform/girls-sat-winter.jpg",
    items: [
      "House jacket and sweatpants (color-coded)",
      "Black shoes and woolen socks",
    ],
    color: "#f4c842",
    border: "rgba(244,200,66,0.2)",
  },
];

const Uniform = () => {
  return (
    <section className="relative min-h-screen pt-36 md:pt-40 pb-20 px-6 md:px-16 md:pt-[96px] overflow-hidden">
      <div
        className="absolute top-0 right-0 w-96 h-96 pointer-events-none"
        style={{
          background:
            "radial-gradient(circle, rgba(236,72,153,0.06) 0%, transparent 70%)",
        }}
      />

      <div className="max-w-6xl mx-auto relative z-10">
        <Link
          to="/information"
          className="inline-block text-sm font-bold tracking-wide mb-8"
          style={{ fontFamily: "Nunito, sans-serif", color: "#f4c842" }}
        >
          ← Back to Information
        </Link>

        <h1
          className="uppercase mb-4"
          style={{
            fontFamily: "Orbitron, sans-serif",
            fontWeight: 900,
            fontSize: "clamp(1.8rem, 4vw, 3rem)",
            color: "#f0f5ff",
          }}
        >
          School Uniform
        </h1>
        <div className="cosmic-divider mb-10" />

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {uniformData.map((u, i) => (
            <div
              key={i}
              className="glass-card overflow-hidden transition-all duration-300 hover:scale-[1.02]"
              style={{ borderColor: u.border }}
            >
              <div
                className="w-full h-40 bg-center bg-cover relative"
                style={{
                  backgroundImage: `url(${u.image})`,
                  backgroundSize: "cover",
                }}
              >
                <div
                  className="absolute inset-0"
                  style={{
                    background:
                      "linear-gradient(to bottom, transparent 40%, rgba(2,8,16,0.9) 100%)",
                  }}
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-3">
                  <div
                    className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-sm"
                    style={{
                      background: `${u.color}18`,
                      border: `1px solid ${u.border}`,
                      color: u.color,
                    }}
                  >
                    {u.title.includes("Girls") ? (
                      <FaUserGraduate size={14} />
                    ) : (
                      <FaUserAlt size={14} />
                    )}
                  </div>
                  <h4
                    className="font-bold leading-tight"
                    style={{
                      fontFamily: "Cinzel, serif",
                      color: "#f0f5ff",
                      fontSize: "0.8rem",
                    }}
                  >
                    {u.title}
                  </h4>
                </div>
                <ul
                  className="space-y-1"
                  style={{
                    fontFamily: "Nunito, sans-serif",
                    color: "#8899b8",
                    fontSize: "0.82rem",
                  }}
                >
                  {u.items.map((item, ii) => (
                    <li key={ii} className="flex items-start gap-2">
                      <span
                        style={{
                          color: u.color,
                          marginTop: "4px",
                          fontSize: "0.45rem",
                        }}
                      >
                        ●
                      </span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Uniform;
